
import React from 'react';
import {Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  Login,
  Dashboard,
  Admin_ACA16ForwardedSignatureCoursesList,
  BOS_ExternalCreditApprovalList,
  BOSChangePassword
 
} from '../Pages/Bos'; 



import ProtectedRoute from '../component/ProtectedRoute';

const BosRoutes = () => (

  <Routes>

    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} role={21} />} />
    <Route path="/adminaca16forwardedsignaturecourses" element={<ProtectedRoute element={<Admin_ACA16ForwardedSignatureCoursesList />} role={21} />} />
    <Route path="/BOSChangePassword" element={<ProtectedRoute element={<BOSChangePassword />} role={21} />} />
    <Route path="/bosexternalcreditapprovallist" element={<ProtectedRoute element={<BOS_ExternalCreditApprovalList />} role={21} />} />
   
  </Routes>

);

export default BosRoutes;

